import React from 'react';
import "./OurPlan.css";
import { ReactSVG } from 'react-svg';
import check from "../assets/plan-check.svg";
import {ReactComponent as Plan} from '../assets/model-free.svg';
import {ReactComponent as BL} from '../assets/plan-bottom-left.svg';
import {ReactComponent as BR} from '../assets/plan-bottom-right.svg';
import {ReactComponent as ML} from '../assets/plan-middle-left.svg';
import {ReactComponent as MR} from '../assets/plan-middle-right.svg';
import {ReactComponent as TL} from '../assets/plan-top-left.svg';
import {ReactComponent as TR} from '../assets/plan-top-right.svg';
import { TFunction } from 'i18next';

interface props {
    t: TFunction
}

const OurPlan = ({t}:props) => {
    return (
        <div className='slide' id='our-plan'>
            <BL className="plan__bottom-left plan__abs">
            </BL>
            <BR className="plan__bottom-right plan__abs"></BR>
            <ML className="plan__middle-left plan__abs"></ML>
            <MR className="plan__middle-right plan__abs"></MR>
            <TL className="plan__top-left plan__abs"></TL>
            <TR className="plan__top-right plan__abs"></TR>
            <h2 className='slide-title'>{t("ourPlanTitle")}</h2>
            <div className="plan__model">
                <div className="plan__sub-title">{t("ourPlanCardSubtitle")}</div>
                <div className="plan__title">{t("ourPlanCardTitle")}</div>
                <Plan className="plan__svg"></Plan>
                <ul className="plan__benefits">
                    <li className="plan__benefits__items">
                        <ReactSVG src={check} className="plan__benefits__items-check"></ReactSVG>
                        <div className="plan__benefits__items-content">{t('ourPlanLi1')}</div>
                    </li>
                    <li className="plan__benefits__items">
                        <ReactSVG src={check} className="plan__benefits__items-check"></ReactSVG>
                        <div className="plan__benefits__items-content">{t('ourPlanLi2')}</div>
                    </li>
                    <li className="plan__benefits__items">
                        <ReactSVG src={check} className="plan__benefits__items-check"></ReactSVG>
                        <div className="plan__benefits__items-content">{t('ourPlanLi3')}</div>
                    </li>
                    <li className="plan__benefits__items">
                        <ReactSVG src={check} className="plan__benefits__items-check"></ReactSVG>
                        <div className="plan__benefits__items-content">{t('ourPlanLi4')}</div>
                    </li>
                    <li className="plan__benefits__items">
                        <ReactSVG src={check} className="plan__benefits__items-check"></ReactSVG>
                        <div className="plan__benefits__items-content">{t('ourPlanLi5')}</div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default OurPlan;